'use strict';

var deviceAgent = navigator.userAgent.toLowerCase();
var agentID = deviceAgent.match(/(iphone|ipod|ipad|android|webos|iemobile|opera mini|blackberry)/);

$(document).ready(function() {

   if (agentID) {
      $('html').addClass('is-mobile');
   }

   $('img.svg').each(function() {
      var $img = $(this);
      var imgID = $img.attr('id');
      var imgClass = $img.attr('class');
      var imgURL = $img.attr('src');
      var imgWidth = $img.attr('width');

      $.get(imgURL, function(data) {
         // Get the SVG tag, ignore the rest
         var $svg = $(data).find('svg');

         // Add replaced image's ID to the new SVG
         if (typeof imgID !== 'undefined') {
            $svg = $svg.attr('id', imgID);
         }
         // Add replaced image's classes to the new SVG
         if (typeof imgClass !== 'undefined') {
            $svg = $svg.attr('class', imgClass + ' replaced-svg');
         }

         if (typeof imgWidth !== 'undefined') {
            $svg = $svg.attr('width', imgWidth);
         }

         // Remove any invalid XML tags as per http://validator.w3.org
         $svg = $svg.removeAttr('xmlns:a');

         // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
         if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
            $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
         }

         // Replace image with new SVG
         $img.replaceWith($svg);

      }, 'xml');
   });

    $('.modal').on('show.bs.modal', function() {
      $('#hamburger-nav-header, #nav-header, .header__options').removeClass('is-active');
      $('html, main, footer').removeClass('nav-is-open');
      $('.arrow-dropdown + ul').stop().slideUp(300);
      $('.arrow-dropdown').removeClass('is-active');

    });


   $('#hamburger-nav-header').on('click', function(event) {
      event.preventDefault();
      
      if( !$(this).hasClass('is-active') ){
         $('#hamburger-nav-header, #nav-header, .header__options').addClass('is-active');
         $('html, main, footer').addClass('nav-is-open');
      }else{
         $('#hamburger-nav-header, #nav-header, .header__options').removeClass('is-active');
         $('html, main, footer').removeClass('nav-is-open');
         $('.arrow-dropdown + ul').stop().slideUp(300);
         $('.arrow-dropdown').removeClass('is-active');
      }
      
   });

  $('.header-nav ul li').each(function(index, el) {
    if ($(el).has('> ul').length > 0){
      $(el).addClass('is-dropdown');
      $('<span class="arrow-dropdown"></span>').insertBefore( $(el).find('> ul') );
    }
  });

  $('body').on('click', 'li.is-dropdown .arrow-dropdown', function(event) {
    if ( $(window).width() < 992 ){
      event.preventDefault();
      $(this).find('+ ul').stop().slideToggle(300);
      $(this).toggleClass('is-active');
    }
  });

   if ( $('.hero-slide .swiper-slide').length > 1 ) {

      var heroSlide = new Swiper('.hero-slide', {
         speed: 1000,
         parallax: true,
         pagination: {
            el: '.swiper-pagination',
            clickable: true,
            renderBullet: function(index, className) {
               var index = (index + 1) < 10 ? '0' + (index + 1) : (index + 1);
               return '<span class="' + className + '"><span class="bullet-index">' + index + '</span></span>';
            },
         },
      });
   }

   var productSlide = new Swiper('.product-slide', {
      speed: 1000,
      parallax: true,
      navigation: {
         nextEl: '.product-slide__button-next',
         prevEl: '.product-slide__button-prev',
      },
      pagination: {
         el: '.product-slide__pagination',
      }
   });

   var productVariationSlide = new Swiper('.product-variation-slide', {
      speed: 1000,
      parallax: true,
      navigation: {
         nextEl: '.product-variation-slide__button-next',
         prevEl: '.product-variation-slide__button-prev',
      },
   });

   var productCarousel = new Swiper('.product-carousel', {
      speed: 1000,
      initialSlide: 1,
      parallax: true,
      loop: true,
      spaceBetween: 200,
      navigation: {
         nextEl: '.product-carousel__button-next',
         prevEl: '.product-carousel__button-prev',
      },
      pagination: {
         el: '.product-carousel__pagination',
      },
      breakpoints: {
         1680: {
            spaceBetween: 150
         },
      }
   });

   var partnerCarouselProps = {
      speed: 1000,
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 30,
      loop: true,
      // centeredSlides: true,
      pagination: {
         el: '.partner-carousel__pagination',
         clickable: true,
      },
      breakpoints: {
         768: {
            slidesPerView: 2,
            slidesPerGroup: 2,
         },
         380: {
            slidesPerView: 1,
            slidesPerGroup: 1,
         },
      }
   };

   if ($(window).width() > 768) {
      if ($('.partner-carousel .swiper-slide').length > 3) {
         var partnerCarousel = new Swiper('.partner-carousel', partnerCarouselProps);
      }
   }else{
      var partnerCarousel = new Swiper('.partner-carousel', partnerCarouselProps);
   }

   var quoteCarousel = new Swiper('.quote-carousel', {
      speed: 1000,
      autoHeight: true,
      effect: 'fade',
      navigation: {
         nextEl: '.quote-carousel__button-next',
         prevEl: '.quote-carousel__button-prev',
      },
   });

   $('body').on('click', '.swiper-slide.swiper-slide-prev a, .swiper-slide.swiper-slide-next a', function(event) {
     event.preventDefault();
   });

   $(window).on('load resize', function(event) {
      event.preventDefault();

      $('.snippet-project__image img').each(function(index, el) {
        $(el).height( $(el).width() );
      });

   });

   $('body').on('click', '.jumper', function(e) {
      e.preventDefault();
      var anchor = $(this).attr('href');
      $('html,body').animate({ scrollTop: $(anchor).offset().top }, 1000);
   });

   $('.scroll-top').on('click', function(event) {
      event.preventDefault();
      $('html,body').animate({ scrollTop: $('html').offset().top }, 1000);
   });

   // Modal com mensagem de obrigado e mudança de url para mapeamento de campanha
   function displayFormSuccess(){
      $('.modal').modal('hide');
      $('#obrigado').modal('show');
      window.location.href = baseURL + '#obrigado';
   }

   // Validação de formulário de Visita
   $('.form-visita').validate({
      errorPlacement: function(error, element) {
         return false;
      },
      rules: {
         visita_nome: {
            required: true,
            minlength: 2
         },
         visita_email: {
            required: true,
            email: true,
         },
         visita_telefone: {
            required: true,
            minlength: 2
         },
         visita_captcha: {
            required: true
         },

      },
      submitHandler: function(form) {
         var formData = $(form).serialize();

         $.post('controller/envia-visita.php', formData, function(data, textStatus, xhr) {
            if (data == '1') { // sucesso
               $(form)[0].reset();

               /* Mensagem de obrigado simples */
               // $(form).find('.result-form').hide().html('<span class="msg-success">Mensagem enviada com sucesso!</span>').fadeIn();

               /* Mensagem de obrigado com redirect de Url para mapear na campanha */
               displayFormSuccess();

            } else { // Erro
               $(form).find('.result-form').hide().html('<span class="msg-error">Erro ao enviar mensagem!</span>').fadeIn();
            }
         });

      }
   });

   // Validação de formulário de Contato
   $('.form-contato').validate({
      errorPlacement: function(error, element) {
         return false;
      },
      rules: {
         contato_desejo: {
            required: true,
         },
         contato_produto: {
            required: true,
         },
         contato_tipo: {
            required: true,
         },
         contato_medidas: {
            required: true,
            minlength: 2
         },
         contato_endereco: {
            required: true,
            minlength: 2
         },
         contato_dia: {
            required: true,
            minlength: 2
         },
         contato_nome: {
            required: true,
            minlength: 2
         },
         contato_email: {
            required: true,
            email: true,
         },
         contato_telefone: {
            required: true,
            minlength: 2
         },
         contato_captcha: {
            required: true
         },

      },
      submitHandler: function(form) {
         var formData = $(form).serialize();

         $.post('controller/envia-contato.php', formData, function(data, textStatus, xhr) {
            if (data == '1') { // sucesso
               $(form)[0].reset();

               /* Mensagem de obrigado simples */
               // $(form).find('.result-form').hide().html('<span class="msg-success">Mensagem enviada com sucesso!</span>').fadeIn();

               /* Mensagem de obrigado com redirect de Url para mapear na campanha */
               displayFormSuccess();

            } else { // Erro
               $(form).find('.result-form').hide().html('<span class="msg-error">Erro ao enviar mensagem!</span>').fadeIn();
            }
         });

      }
   });

   // Validação formulário de apresentação
   $('.form-apresentacao').validate({
      errorPlacement: function(error, element) {
         return false;
      },
      rules: {
         apresentacao_nome: {
            required: true,
            minlength: 2
         },
         apresentacao_email: {
            required: true,
            email: true,
         },
         apresentacao_telefone: {
            required: true,
            minlength: 2
         },

      },
      submitHandler: function(form) {
         var formData = $(form).serialize();

         $.post('controller/envia-apresentacao.php', formData, function(data, textStatus, xhr) {
            if (data == '1') { // sucesso
               $(form)[0].reset();

               /* Mensagem de obrigado simples */
               // $(form).find('.result-form').hide().html('<span class="msg-success">Mensagem enviada com sucesso!</span>').fadeIn();

               /* Mensagem de obrigado com redirect de Url para mapear na campanha */
               displayFormSuccess();


            } else { // Erro
               $(form).find('.result-form').hide().html('<span class="msg-error">Erro ao enviar mensagem!</span>').fadeIn();
            }
         });

      }
   });

   $('#load_projects').on('click', function(event) {
      event.preventDefault();

      $.get('controller/carrega-projetos.php', function(data) {
         var projects = JSON.parse(data);

         $.each(projects.itens, function(index, el) {
            $('#result_projects').append(
               '<div class="col-sm-6 col-lg-4 animated fadeInUp">' + 
                  '<article class="snippet-project">' + 
                     '<figure class="snippet-project__image">' + 
                        '<a href="' + el.link + '">' + 
                           '<img src="' + el.image.url + '" alt="' + el.image.alt + '" title="' + el.image.title + '">' + 
                        '</a>' + 
                        '<span class="line-vertical"></span>' + 
                     '</figure>' + 
                     '<div class="snippet-project__caption">' + 
                        '<a href="' + el.category.link + '" class="snippet-project__caption-category small-title">' + el.category.title + '</a>' + 
                        '<h2 class="snippet-project__caption-title h3">' + el.title + '</h2>' + 
                     '</div>' + 
                  '</article>' + 
               '</div>'
            );
         });

         if( projects.end == 1 ){  // Se o valor for 1, indica que não existem mais itens a serem carregados

            // Esconde o botão de carregar mais
            $('#load_projects').fadeOut().remove();

         }

      });
   });


   $('#load_blog').on('click', function(event) {
      event.preventDefault();

      $.get('controller/carrega-blog.php', function(data) {
         var news = JSON.parse(data);

         $.each(news.itens, function(index, el) {
            $('#result_blog').append(
               '<article class="snippet-news row align-items-center justify-content-center animated fadeInUp">' + 
                  '<div class="col-lg-6">' + 
                     '<figure class="snippet-news__image zoom-image">' + 
                        '<a href="' + el.link + '">' + 
                           '<img src="' + el.image.url + '" alt="' + el.image.alt + '" title="' + el.image.title + '">' + 
                        '</a>' + 
                     '</figure>' + 
                  '</div>' + 

                  '<div class="col-lg-5">' + 
                     '<div class="snippet-news__caption">' + 
                        '<span class="line-horizontal-news line-yellow"></span>' + 
                        '<span class="snippet-news__caption-category small-title">' + el.category.title + '</span>' + 
                        '<h2 class="snippet-news__caption-title h3">' + el.title + '</h2>' + 
                        '<a href="' + el.link + '" class="btn-default btn-default-blog">mais</a>' + 
                     '</div>' + 
                  '</div>' + 
               '</article>'
            );
         });


         if( news.end == 1 ){  // Se o valor for 1, indica que não existem mais itens a serem carregados

            // Esconde o botão de carregar mais
            $('#load_blog').fadeOut().remove();

         }
      });
   });


   // Abrindo Modal por url
   var pageUrl = window.location.href.split('#');

   if (pageUrl[1]) {
      if (pageUrl[1] == 'contato')
         $('#contato').modal('show');

      if (pageUrl[1] == 'visita')
         $('#visita').modal('show');

      // if (pageUrl[1] == 'obrigado')
      //    $('#obrigado').modal('show');

   }


/** Modal de apresentação
   setTimeout(function() {
      if (!$('body').hasClass('modal-open')) {
         $('#apresentacao').modal('show');
      }
   }, 30000);
 */

   // Formatando campos com mascaras
   var SPMaskBehavior = function(val) {
         return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
      },
      spOptions = {
         onKeyPress: function(val, e, field, options) {
            field.mask(SPMaskBehavior.apply({}, arguments), options);
         }
      };

   $('.mask-phone').mask(SPMaskBehavior, spOptions);
   $('.mask-date').mask('99/99/9999');
   $('.mask-cep').mask('00000-000');
   $('.mask-cpf').mask('000.000.000-00');
   $('.mask-cnpj').mask('00.000.000/0000-00');
   $('.mask-number').mask('0#');

   // LightBox
   $(".open-fancybox").fancybox({
      // 'titleShow'     : false
   });

   SmoothScroll({
      animationTime: 1500,
      stepSize: 60,
      accelerationDelta: 1000,
   });

   // particles JS
   var configParticles = {
     "particles": {
       "number": {
         "value": 80,
         "density": {
           "enable": true,
           "value_area": 800
         }
       },
       "color": {
         "value": "#e3e3e3"
       },
       "shape": {
         "type": "circle",
         "stroke": {
           "width": 0,
           "color": "#000000"
         },
         "polygon": {
           "nb_sides": 5
         },
         "image": {
           "src": "img/github.svg",
           "width": 100,
           "height": 100
         }
       },
       "opacity": {
         "value": 1,
         "random": false,
         "anim": {
           "enable": false,
           "speed": 1,
           "opacity_min": 0.1,
           "sync": false
         }
       },
       "size": {
         "value": 3,
         "random": true,
         "anim": {
           "enable": false,
           "speed": 40,
           "size_min": 0.1,
           "sync": false
         }
       },
       "line_linked": {
         "enable": true,
         "distance": 189.39543399174545,
         "color": "#e3e3e3",
         "opacity": 0.4,
         "width": 2
       },
       "move": {
         "enable": true,
         "speed": 0.8,
         "direction": "none",
         "random": false,
         "straight": false,
         "out_mode": "out",
         "bounce": false,
         "attract": {
           "enable": false,
           "rotateX": 600,
           "rotateY": 1200
         }
       }
     },
     "interactivity": {
       "detect_on": "canvas",
       "events": {
         "onhover": {
           "enable": false,
           "mode": "repulse"
         },
         "onclick": {
           "enable": true,
           "mode": "push"
         },
         "resize": true
       },
       "modes": {
         "grab": {
           "distance": 400,
           "line_linked": {
             "opacity": 1
           }
         },
         "bubble": {
           "distance": 400,
           "size": 40,
           "duration": 2,
           "opacity": 8,
           "speed": 3
         },
         "repulse": {
           "distance": 200,
           "duration": 0.4
         },
         "push": {
           "particles_nb": 4
         },
         "remove": {
           "particles_nb": 2
         }
       }
     },
     "retina_detect": true
  };

  if( $('#particles-inner-top').length > 0 )
    particlesJS("particles-inner-top", configParticles);
  
  if( $('#particles-inner-left').length > 0 )
    particlesJS("particles-inner-left", configParticles);

  if( $('#particles-inner-right').length > 0 )
    particlesJS("particles-inner-right", configParticles);

  if( $('#particles-inner-left-home').length > 0 )
    particlesJS("particles-inner-left-home", configParticles);

});

$(window).on('load', function() {
   setTimeout(function(){
      $('body').addClass('is-loaded');
   }, 300);

   if (!agentID) {
      var rellax = new Rellax('.rellax', { breakpoints: [576, 768, 1201] });

      let wow = new WOW({
         boxClass: 'wow',
         animateClass: 'animated',
         offset: 40,
         mobile: true,
         live: true
      });

      wow.init();
   }

});
